import { indexBy, map, prop } from 'rambda';
import { FileResourceDTO } from '@higo/api/lib/models/fileResourceDTO';
import { FileResource } from '@higo/common/src/types';

export const indexByFileName = indexBy<FileResource>('fileName');
export const remapToFileIdArray = map<FileResourceDTO, number>(prop('fileId'));
